<template>
  <div class="main">
    <FormWrapper :action="route('enroll.classroom.confirm')" method="POST">
      <div class="title-bar">
        <div class="row">
          <div class="col-12 col-md-6 mb-4 text-center text-md-left">
            <h1 class="mb-0">Classroom Enrollment</h1>
          </div>
          <div class="col-12 col-md-6 mb-3 text-center text-md-right">
            <button type="submit" class="btn btn-success w-75 mb-2 w-sm-auto mr-sm-2 mb-sm-0">
              Confirm Registration
            </button>
            <a class="btn btn-info w-75 w-sm-auto" :href="route('event-calendar.index')">Back to Calendar</a>
          </div>
        </div>
      </div>
      <div class="enrollment-cart content py-4 px-xl-2">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <transition name="fade">
                <Alert v-if="hasAlert" :alert="alert" />
              </transition>
            </div>
            <div class="col-12 col-lg-8">
              <div v-if="items.length > 0">
                <CartItem
                  v-for="(item, i) in items"
                  :key="i"
                  :item="item"
                  :index="i"
                  type="classroom"
                  @change-brand="changeBrand"
                  @edit-form="editForm"
                  @edit-nate="editNate"
                  @remove="removeItem"
                />
              </div>
              <div v-else class="alert alert-info">
                <span>
                  You do not have any event registrations in queue.
                  <a :href="route('event-calendar.index')" class="text-dark">
                    <u>Return to the Event Calendar</u>
                  </a>.
                </span>
              </div>
            </div>
            <div v-if="items.length > 0" class="col-12 col-lg-4">
              <div class="sticky-top panel p-4 text-center">
                <h4>Summary</h4>
                <h5 class="text-primary font-weight-bold mb-1">
                  {{ `${numUsers} student(s), ${numEvents} event(s)` }}
                </h5>
                <p class="font-size-sm">will be registered</p>
                <button class="btn btn-success btn-arrow-right mb-4 w-100 w-sm-auto" type="submit">
                  <span class="text">Confirm Registration</span>
                  <icon icon="arrow-right" class="svg-icon" />
                </button>
                <p class="font-size-sm">
                  <span>
                    Before confirming registration, please review the items your
                    registration queue and verify that all information provided
                    is correct.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FormWrapper>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import CartItem from "../partials/CartItem";
import EditEnrollmentBrand from "../partials/EditEnrollmentBrand";
import EditEnrollmentForm from "../partials/EditEnrollmentForm";
import EditNateCredit from "../partials/EditNateCredit.vue";

export default {
  mixins: [DisplaysAlerts],
  components: { CartItem },
  props: {
    queue: { type: Object, required: true },
    removed: { type: Array, default: () => [] },
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    numEvents() {
      var events = [];
      this.items.forEach((item) => {
        if (item.enrollable?.id && !events.includes(item.enrollable.id)) {
          events.push(item.enrollable.id);
        }
      });
      return events.length;
    },
    numUsers() {
      var users = [];
      this.items.forEach((item) => {
        if (!users.includes(item.user_id)) {
          users.push(item.user_id);
        }
      });
      return users.length;
    },
  },
  methods: {
    refresh() {
      this.axios(this.route("enroll.classroom.cart.refresh")).then(
        (response) => {
          this.items = response.data.items;
        }
      );
    },
    removeItem(item) {
      let me = this;
      this.axios
        .delete(
          this.route("enroll.classroom.cart.remove", {
            type: item.item_type,
            enrollment: item.id,
          })
        )
        .then(() => {
          me.refresh();
          me.showAlert("success", "Your changes have been applied", true);
        });
    },
    changeBrand(item) {
      let me = this;
      this.$modal(EditEnrollmentBrand, { enrollment: item })
        .then(() => {
          me.refresh();
          me.showAlert("success", "Your changes have been applied", true);
        })
        .catch(() => {});
    },
    editForm(item) {
      let me = this;
      this.$modal(EditEnrollmentForm, { enrollment: item })
        .then(() => {
          me.refresh();
          me.showAlert("success", "Your changes have been applied", true);
        })
        .catch(() => {});
    },
    editNate(item, type = "online") {
      let me = this;
      this.$modal(EditNateCredit, { enrollment: item, type: type })
          .then(() => {
            me.refresh();
            me.showAlert("success", "Your cart has been updated", true);
          })
          .catch(() => {});
    },
  },
  created() {
    this.items = this.queue.items;
  },
};
</script>